// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TradeAccountForm.css */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.trade-account-container {
  min-height: 100vh;
  background-color: #f8f8f8;
  padding: 20px;
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  min-height: calc(100vh - 40px);
  align-items: center;
}

/* Image Section */
.image-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.interior-showcase {
  width: 100%;
  max-width: 500px;
  height: 400px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.room-display {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f4e6d2 0%, #e8d4b8 100%);
  position: relative;
}

.wall-panels {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 60%;
  background: linear-gradient(to right, 
    transparent 0%, 
    transparent 8%, 
    rgba(199, 166, 128, 0.3) 8%, 
    rgba(199, 166, 128, 0.3) 10%, 
    transparent 10%),
    linear-gradient(to right, 
    transparent 0%, 
    transparent 18%, 
    rgba(199, 166, 128, 0.3) 18%, 
    rgba(199, 166, 128, 0.3) 20%, 
    transparent 20%);
  background-repeat: repeat-x;
  background-size: 100px 100%;
}

.wooden-floor {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: 
    linear-gradient(90deg, #d4a574 0%, #c89660 50%, #d4a574 100%),
    repeating-linear-gradient(90deg, 
      transparent 0%, 
      transparent 48px, 
      rgba(139, 69, 19, 0.1) 48px, 
      rgba(139, 69, 19, 0.1) 50px);
}

.furniture-arrangement {
  position: absolute;
  bottom: 25%;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  height: 50%;
}

.white-chair {
  position: absolute;
  right: 30%;
  bottom: 20%;
  width: 60px;
  height: 80px;
  background: #ffffff;
  border-radius: 8px 8px 4px 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.white-chair::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 5px;
  right: 5px;
  height: 40px;
  background: #ffffff;
  border-radius: 6px 6px 0 0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.shelving-unit {
  position: absolute;
  left: 10%;
  bottom: 15%;
  width: 40px;
  height: 100px;
  background: #2c2c2c;
  border-radius: 2px;
}

.shelving-unit::before,
.shelving-unit::after {
  content: '';
  position: absolute;
  left: 2px;
  right: 2px;
  height: 2px;
  background: #444;
}

.shelving-unit::before {
  top: 25%;
}

.shelving-unit::after {
  top: 50%;
}

.floor-lamp {
  position: absolute;
  left: 5%;
  bottom: 10%;
  width: 8px;
  height: 80px;
  background: #2c2c2c;
  border-radius: 4px;
}

.floor-lamp::before {
  content: '';
  position: absolute;
  top: -15px;
  left: -8px;
  width: 24px;
  height: 24px;
  background: #f5f5f5;
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.decorative-blocks {
  position: absolute;
  right: 10%;
  bottom: 10%;
}

.block {
  background: #8b4513;
  border-radius: 2px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.block-1 {
  width: 50px;
  height: 30px;
  margin-bottom: 2px;
}

.block-2 {
  width: 35px;
  height: 25px;
  margin-left: 15px;
}

/* Form Section */
.form-section {
  padding: 40px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.form-title {
  font-size: 2.5rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 40px;
  letter-spacing: -0.5px;
}

.form-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-row.full-width {
  grid-template-columns: 1fr;
}

.input-group {
  position: relative;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: inherit;
  background: #f9f9f9;
  transition: all 0.3s ease;
  outline: none;
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  border-color: #333;
  background: white;
  box-shadow: 0 0 0 3px rgba(51, 51, 51, 0.1);
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: #999;
  font-weight: 400;
}

.form-select {
  cursor: pointer;
  color: #999;
}

.form-select:focus,
.form-select:valid {
  color: #333;
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
  font-family: inherit;
}

.submit-button {
  background: #333;
  color: white;
  border: none;
  padding: 16px 40px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 20px;
  min-width: 120px;
}

.submit-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.submit-button:active {
  transform: translateY(0);
}

/* Company Information Section */
.company-info {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #e0e0e0;
}

.info-title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 14px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 16px;
  color: #333;
  font-weight: 400;
}

/* Mobile Responsive */
@media (max-width: 1024px) {
  .content-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 20px 0;
  }

  .image-section {
    order: 1;
  }

  .form-section {
    order: 2;
    padding: 30px;
  }

  .interior-showcase {
    max-width: 400px;
    height: 300px;
  }
}

@media (max-width: 768px) {
  .trade-account-container {
    padding: 15px;
  }

  .form-section {
    padding: 25px 20px;
  }

  .form-title {
    font-size: 2rem;
    margin-bottom: 30px;
  }

  .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .form-input,
  .form-select,
  .form-textarea {
    padding: 14px 16px;
    font-size: 15px;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .interior-showcase {
    max-width: 100%;
    height: 250px;
  }
}

@media (max-width: 480px) {
  .form-section {
    padding: 20px 15px;
  }

  .form-title {
    font-size: 1.75rem;
    margin-bottom: 25px;
  }

  .form-input,
  .form-select,
  .form-textarea {
    padding: 12px 14px;
    font-size: 14px;
  }

  .submit-button {
    padding: 14px 30px;
    font-size: 15px;
  }

  .interior-showcase {
    height: 200px;
  }

  .info-title {
    font-size: 1.25rem;
  }

  .info-value {
    font-size: 15px;
  }
}
/* ProgramContactSections.css */

.program-contact-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
}

.section-card {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid #d9d9d9;
  transition: all 0.3s ease;
}

.section-card:hover {
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 2px solid #d9d9d9;
}

.icon-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.clock-icon {
  background: #000000;
}

.phone-icon {
  background: #000000;
}

.section-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #000;
  margin: 0;
  letter-spacing: -0.3px;
}

/* Working Hours Section */
.working-hours {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 20px;
}

.hour-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  margin: 1px 0;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
}


.hour-row.active {
  background: #000;
  color: white;
  font-weight: 600;
}


.hour-row.closed {
  background: #f8f9fa;
  color: #6c757d;
}

.day-name {
  font-size: 0.95rem;
  font-weight: 500;
}

.hours-time {
  font-size: 0.9rem;
  font-weight: 500;
  color: #4a5568;
}

.hour-row.active .hours-time {
  color: rgb(0, 0, 0);
}

.closed-text {
  color: #dc3545;
  font-style: italic;
  font-weight: 500;
}

.schedule-note {
  font-size: 0.85rem;
  color: #6c757d;
  font-style: italic;
  padding: 10px 0;
  border-top: 1px solid #d9d9d9;
  text-align: center;
}

/* Contact Information Section */
.contact-info {
  display: flex;
  flex-direction: column;
  gap: 25px;
}

.contact-item1 {
  display: flex;
  align-items: flex-start;
  gap: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
}

.contact-item1:hover {
  transform: translateY(-1px);
}

.contact-icon {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
}

.contact-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
  cursor: pointer;
}

.contact-label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #4a5568;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}

.contact-value {
  font-size: 1rem;
  font-weight: 500;
  color: #000;
  line-height: 1.4;
}

.address-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .program-contact-container {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 15px;
    margin: 20px auto;
  }

  .section-card {
    padding: 25px 20px;
  }

  .section-header {
    margin-bottom: 20px;
    padding-bottom: 12px;
  }

  .icon-wrapper {
    width: 35px;
    height: 35px;
  }

  .section-title {
    font-size: 1.3rem;
  }

  .hour-row {
    padding: 10px 14px;
    margin: 0.5px 0;
  }

  .day-name {
    font-size: 0.9rem;
  }

  .hours-time {
    font-size: 0.85rem;
  }

  .contact-item1 {
    padding: 12px;
    gap: 12px;
  }

  .contact-icon {
    width: 30px;
    height: 30px;
  }

  .contact-label {
    font-size: 0.85rem;
  }

  .contact-value {
    font-size: 0.95rem;
  }

  .schedule-note {
    font-size: 0.8rem;
    padding: 8px 0;
  }
}

@media (max-width: 480px) {
  .program-contact-container {
    padding: 0 10px;
    margin: 15px auto;
    gap: 15px;
  }

  .section-card {
    padding: 20px 15px;
    border-radius: 8px;
  }

  .section-header {
    gap: 10px;
    margin-bottom: 18px;
  }

  .section-title {
    font-size: 1.2rem;
  }

  .icon-wrapper {
    width: 32px;
    height: 32px;
  }

  .hour-row {
    padding: 8px 12px;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    text-align: left;
  }

  .hours-time {
    align-self: flex-end;
    font-size: 0.8rem;
  }

  .contact-item1 {
    padding: 10px;
    gap: 10px;
  }

  .contact-details {
    gap: 3px;
  }

  .contact-label {
    font-size: 0.8rem;
  }

  .contact-value {
    font-size: 0.9rem;
  }

  .schedule-note {
    font-size: 0.75rem;
  }
}

/* Dark mode support (optional) */
@media (prefers-color-scheme: dark) {
  .section-card {
    border-color: #333;
    color: white;
  }

  .section-title {
    color: rgb(0, 0, 0);
  }

  .hour-row {
    border-color: #444;
    color: rgb(0, 0, 0);
  }


  .hour-row.active {
    background: white;
    color: black;
  }

  .contact-item1 {
    border-color: #444;
  }

  .contact-value {
    color: rgb(0, 0, 0);
  }

  .schedule-note {
    color: #999;
    border-color: #444;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Contact.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;;;;;;oBAWkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;kCAMgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;IAGE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,+BAA+B;;AAE/B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,sBAAsB;AACxB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,iCAAiC;AACjC;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":["/* TradeAccountForm.css */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.trade-account-container {\n  min-height: 100vh;\n  background-color: #f8f8f8;\n  padding: 20px;\n}\n\n.content-wrapper {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  min-height: calc(100vh - 40px);\n  align-items: center;\n}\n\n/* Image Section */\n.image-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n}\n\n.interior-showcase {\n  width: 100%;\n  max-width: 500px;\n  height: 400px;\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n}\n\n.room-display {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #f4e6d2 0%, #e8d4b8 100%);\n  position: relative;\n}\n\n.wall-panels {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 60%;\n  background: linear-gradient(to right, \n    transparent 0%, \n    transparent 8%, \n    rgba(199, 166, 128, 0.3) 8%, \n    rgba(199, 166, 128, 0.3) 10%, \n    transparent 10%),\n    linear-gradient(to right, \n    transparent 0%, \n    transparent 18%, \n    rgba(199, 166, 128, 0.3) 18%, \n    rgba(199, 166, 128, 0.3) 20%, \n    transparent 20%);\n  background-repeat: repeat-x;\n  background-size: 100px 100%;\n}\n\n.wooden-floor {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 40%;\n  background: \n    linear-gradient(90deg, #d4a574 0%, #c89660 50%, #d4a574 100%),\n    repeating-linear-gradient(90deg, \n      transparent 0%, \n      transparent 48px, \n      rgba(139, 69, 19, 0.1) 48px, \n      rgba(139, 69, 19, 0.1) 50px);\n}\n\n.furniture-arrangement {\n  position: absolute;\n  bottom: 25%;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80%;\n  height: 50%;\n}\n\n.white-chair {\n  position: absolute;\n  right: 30%;\n  bottom: 20%;\n  width: 60px;\n  height: 80px;\n  background: #ffffff;\n  border-radius: 8px 8px 4px 4px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.white-chair::before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 5px;\n  right: 5px;\n  height: 40px;\n  background: #ffffff;\n  border-radius: 6px 6px 0 0;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\n}\n\n.shelving-unit {\n  position: absolute;\n  left: 10%;\n  bottom: 15%;\n  width: 40px;\n  height: 100px;\n  background: #2c2c2c;\n  border-radius: 2px;\n}\n\n.shelving-unit::before,\n.shelving-unit::after {\n  content: '';\n  position: absolute;\n  left: 2px;\n  right: 2px;\n  height: 2px;\n  background: #444;\n}\n\n.shelving-unit::before {\n  top: 25%;\n}\n\n.shelving-unit::after {\n  top: 50%;\n}\n\n.floor-lamp {\n  position: absolute;\n  left: 5%;\n  bottom: 10%;\n  width: 8px;\n  height: 80px;\n  background: #2c2c2c;\n  border-radius: 4px;\n}\n\n.floor-lamp::before {\n  content: '';\n  position: absolute;\n  top: -15px;\n  left: -8px;\n  width: 24px;\n  height: 24px;\n  background: #f5f5f5;\n  border-radius: 50%;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.decorative-blocks {\n  position: absolute;\n  right: 10%;\n  bottom: 10%;\n}\n\n.block {\n  background: #8b4513;\n  border-radius: 2px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.block-1 {\n  width: 50px;\n  height: 30px;\n  margin-bottom: 2px;\n}\n\n.block-2 {\n  width: 35px;\n  height: 25px;\n  margin-left: 15px;\n}\n\n/* Form Section */\n.form-section {\n  padding: 40px;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.form-title {\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: #333;\n  margin-bottom: 40px;\n  letter-spacing: -0.5px;\n}\n\n.form-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n}\n\n.form-row.full-width {\n  grid-template-columns: 1fr;\n}\n\n.input-group {\n  position: relative;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  width: 100%;\n  padding: 16px 20px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 16px;\n  font-family: inherit;\n  background: #f9f9f9;\n  transition: all 0.3s ease;\n  outline: none;\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  border-color: #333;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(51, 51, 51, 0.1);\n}\n\n.form-input::placeholder,\n.form-textarea::placeholder {\n  color: #999;\n  font-weight: 400;\n}\n\n.form-select {\n  cursor: pointer;\n  color: #999;\n}\n\n.form-select:focus,\n.form-select:valid {\n  color: #333;\n}\n\n.form-textarea {\n  resize: vertical;\n  min-height: 120px;\n  font-family: inherit;\n}\n\n.submit-button {\n  background: #333;\n  color: white;\n  border: none;\n  padding: 16px 40px;\n  font-size: 16px;\n  font-weight: 500;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 20px;\n  min-width: 120px;\n}\n\n.submit-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.submit-button:active {\n  transform: translateY(0);\n}\n\n/* Company Information Section */\n.company-info {\n  margin-top: 40px;\n  padding-top: 30px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.info-title {\n  font-size: 1.5rem;\n  font-weight: 500;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.info-label {\n  font-size: 14px;\n  font-weight: 600;\n  color: #666;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.info-value {\n  font-size: 16px;\n  color: #333;\n  font-weight: 400;\n}\n\n/* Mobile Responsive */\n@media (max-width: 1024px) {\n  .content-wrapper {\n    grid-template-columns: 1fr;\n    gap: 30px;\n    padding: 20px 0;\n  }\n\n  .image-section {\n    order: 1;\n  }\n\n  .form-section {\n    order: 2;\n    padding: 30px;\n  }\n\n  .interior-showcase {\n    max-width: 400px;\n    height: 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .trade-account-container {\n    padding: 15px;\n  }\n\n  .form-section {\n    padding: 25px 20px;\n  }\n\n  .form-title {\n    font-size: 2rem;\n    margin-bottom: 30px;\n  }\n\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .form-input,\n  .form-select,\n  .form-textarea {\n    padding: 14px 16px;\n    font-size: 15px;\n  }\n\n  .info-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .interior-showcase {\n    max-width: 100%;\n    height: 250px;\n  }\n}\n\n@media (max-width: 480px) {\n  .form-section {\n    padding: 20px 15px;\n  }\n\n  .form-title {\n    font-size: 1.75rem;\n    margin-bottom: 25px;\n  }\n\n  .form-input,\n  .form-select,\n  .form-textarea {\n    padding: 12px 14px;\n    font-size: 14px;\n  }\n\n  .submit-button {\n    padding: 14px 30px;\n    font-size: 15px;\n  }\n\n  .interior-showcase {\n    height: 200px;\n  }\n\n  .info-title {\n    font-size: 1.25rem;\n  }\n\n  .info-value {\n    font-size: 15px;\n  }\n}\n/* ProgramContactSections.css */\n\n.program-contact-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 30px;\n  max-width: 1200px;\n  margin: 40px auto;\n  padding: 0 20px;\n}\n\n.section-card {\n  background: white;\n  border-radius: 12px;\n  padding: 30px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  border: 1px solid #d9d9d9;\n  transition: all 0.3s ease;\n}\n\n.section-card:hover {\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.12);\n}\n\n.section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 25px;\n  padding-bottom: 15px;\n  border-bottom: 2px solid #d9d9d9;\n}\n\n.icon-wrapper {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n}\n\n.clock-icon {\n  background: #000000;\n}\n\n.phone-icon {\n  background: #000000;\n}\n\n.section-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #000;\n  margin: 0;\n  letter-spacing: -0.3px;\n}\n\n/* Working Hours Section */\n.working-hours {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 20px;\n}\n\n.hour-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  margin: 1px 0;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  background: #f8f9fa;\n  border: 1px solid #e9ecef;\n}\n\n\n.hour-row.active {\n  background: #000;\n  color: white;\n  font-weight: 600;\n}\n\n\n.hour-row.closed {\n  background: #f8f9fa;\n  color: #6c757d;\n}\n\n.day-name {\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.hours-time {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.hour-row.active .hours-time {\n  color: rgb(0, 0, 0);\n}\n\n.closed-text {\n  color: #dc3545;\n  font-style: italic;\n  font-weight: 500;\n}\n\n.schedule-note {\n  font-size: 0.85rem;\n  color: #6c757d;\n  font-style: italic;\n  padding: 10px 0;\n  border-top: 1px solid #d9d9d9;\n  text-align: center;\n}\n\n/* Contact Information Section */\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n}\n\n.contact-item1 {\n  display: flex;\n  align-items: flex-start;\n  gap: 15px;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border: 1px solid #e9ecef;\n  transition: all 0.2s ease;\n}\n\n.contact-item1:hover {\n  transform: translateY(-1px);\n}\n\n.contact-icon {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  background: #000000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  flex-shrink: 0;\n}\n\n.contact-details {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  cursor: pointer;\n}\n\n.contact-label {\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #4a5568;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 2px;\n}\n\n.contact-value {\n  font-size: 1rem;\n  font-weight: 500;\n  color: #000;\n  line-height: 1.4;\n}\n\n.address-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .program-contact-container {\n    grid-template-columns: 1fr;\n    gap: 20px;\n    padding: 0 15px;\n    margin: 20px auto;\n  }\n\n  .section-card {\n    padding: 25px 20px;\n  }\n\n  .section-header {\n    margin-bottom: 20px;\n    padding-bottom: 12px;\n  }\n\n  .icon-wrapper {\n    width: 35px;\n    height: 35px;\n  }\n\n  .section-title {\n    font-size: 1.3rem;\n  }\n\n  .hour-row {\n    padding: 10px 14px;\n    margin: 0.5px 0;\n  }\n\n  .day-name {\n    font-size: 0.9rem;\n  }\n\n  .hours-time {\n    font-size: 0.85rem;\n  }\n\n  .contact-item1 {\n    padding: 12px;\n    gap: 12px;\n  }\n\n  .contact-icon {\n    width: 30px;\n    height: 30px;\n  }\n\n  .contact-label {\n    font-size: 0.85rem;\n  }\n\n  .contact-value {\n    font-size: 0.95rem;\n  }\n\n  .schedule-note {\n    font-size: 0.8rem;\n    padding: 8px 0;\n  }\n}\n\n@media (max-width: 480px) {\n  .program-contact-container {\n    padding: 0 10px;\n    margin: 15px auto;\n    gap: 15px;\n  }\n\n  .section-card {\n    padding: 20px 15px;\n    border-radius: 8px;\n  }\n\n  .section-header {\n    gap: 10px;\n    margin-bottom: 18px;\n  }\n\n  .section-title {\n    font-size: 1.2rem;\n  }\n\n  .icon-wrapper {\n    width: 32px;\n    height: 32px;\n  }\n\n  .hour-row {\n    padding: 8px 12px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    text-align: left;\n  }\n\n  .hours-time {\n    align-self: flex-end;\n    font-size: 0.8rem;\n  }\n\n  .contact-item1 {\n    padding: 10px;\n    gap: 10px;\n  }\n\n  .contact-details {\n    gap: 3px;\n  }\n\n  .contact-label {\n    font-size: 0.8rem;\n  }\n\n  .contact-value {\n    font-size: 0.9rem;\n  }\n\n  .schedule-note {\n    font-size: 0.75rem;\n  }\n}\n\n/* Dark mode support (optional) */\n@media (prefers-color-scheme: dark) {\n  .section-card {\n    border-color: #333;\n    color: white;\n  }\n\n  .section-title {\n    color: rgb(0, 0, 0);\n  }\n\n  .hour-row {\n    border-color: #444;\n    color: rgb(0, 0, 0);\n  }\n\n\n  .hour-row.active {\n    background: white;\n    color: black;\n  }\n\n  .contact-item1 {\n    border-color: #444;\n  }\n\n  .contact-value {\n    color: rgb(0, 0, 0);\n  }\n\n  .schedule-note {\n    color: #999;\n    border-color: #444;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
